/**
 * SPLIT_COLUMN_CHART_CONFIG: a JSON object representing a schema used to drive the chart
 * in the desktop view of the scenario analysis section.
 */
export const SPLIT_COLUMN_CHART_CONFIG = {
	chart: {
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: '#616161'
		},
		type: 'column',
		marginLeft: -65,
		marginTop: -50
	},

	plotOptions: {
		column: {
			pointWidth: '100',
			groupPadding: 0.85,
			pointPadding: 0,
			stacking: 'normal'
		}
	},
	xAxis: {
		lineWidth: 0,
		minorGridLineWidth: 0,
		gridLineWidth: 0,
		labels: {
			enabled: false
		},
		minorTickLength: 0,
		tickLength: 0,
		title: { text: null }
	},
	yAxis: {
		lineWidth: 0,
		minorGridLineWidth: 0,
		gridLineWidth: 0,
		labels: {
			enabled: false
		},
		minorTickLength: 0,
		tickLength: 0,
		title: { text: null },
		categories: null
	},
	colors: null,
	extensibleData: null
};
